import { MouseEvent, ReactNode, useState } from "react";
import ChevronIcon from "./icons/ChevronIcon";

interface AccordionProps {
    id: string;
    defaultOpen?: boolean;
    headerChildren: ReactNode;
    contentChildren: ReactNode;
}
function Accordion({
    id,
    defaultOpen,
    headerChildren,
    contentChildren,
}: AccordionProps) {
    const [isOpen, setIsOpen] = useState<boolean>(defaultOpen ?? false);

    function toggleAccordion(e: MouseEvent<HTMLButtonElement>): void {
        e.stopPropagation();
        setIsOpen((prevState) => !prevState);
    }

    return (
        // TODO: Change outer button to a div to remove React nesting warning
        <button
            id={id || "accordion"}
            className="relative w-full rounded-lg p-6 shadow-[0px_0px_5px_0px_rgba(0,0,0,0.1)] focus:outline-hidden"
            onClick={toggleAccordion}
        >
            {headerChildren}
            <div className="absolute top-0 right-0 p-6">
                {isOpen ? (
                    <ChevronIcon size="15" direction="up" />
                ) : (
                    <ChevronIcon size="15" />
                )}
            </div>
            {isOpen && <div>{contentChildren}</div>}
        </button>
    );
}

export default Accordion;
